import router from '../index'
import {cloneDeep} from 'lodash'

const module = 'ROUTER_MOVES_'
const STORE_NAME = 'router'

export const ADD_TO_HISTORY = module + 'ADD_TO_HISTORY'
export const SET_CURRENT_URL = module + 'SET_CURRENT_URL'
export const CLEAR_HISTORY = module + 'CLEAR_HISTORY'
export const GO_TO_DASHBOARD = module + 'GO_TO_DASHBOARD'

const actions = {
  [ADD_TO_HISTORY] (context, from) {
    context.commit(ADD_TO_HISTORY, from)
  },
  [SET_CURRENT_URL] (context, currentURL) {
    context.commit(SET_CURRENT_URL, currentURL)
  },
  [CLEAR_HISTORY] (context) {
    context.commit(CLEAR_HISTORY)
  },
  [GO_TO_DASHBOARD] (context) {
    let current = context.state.history
    let hit = false
    while (current) {
      if (current.url.name.includes('audience-hub')) {
        hit = true
        router.push(cloneDeep(current.url)).catch(err => {
          // Ignore NavigationDuplicated error when navigating to the same route
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
        break
      }
      current = current.previous
    }
    if (!hit) {
      router.push(`/audience-hub/targets/${context.getters.username}`).catch(err => {
        // Ignore NavigationDuplicated error when navigating to the same route
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/app/router/store/actions.js